var module = angular.module('akimboApp.filters', []);

// Extends currency filter but removes parentheses
module.filter('akimboCurrency', ["$filter", function ($filter) {
  return function(amount, currencySymbol){
    var currency = $filter('currency');

    if(amount < 0){
      return currency(amount, currencySymbol).replace("(", "-").replace(")", "");
    }

    return currency(amount, currencySymbol);
  };
}]);

module.filter('groupBy', function(){
  return function(items, group, attr){
    return items.filter(function(element, index, array){
      return element[attr] == group;
    });
  };
});

module.filter('widgetFilter', function(){
  return function(widgets, filters){
    var matching = [];

    var groupedWidgets = [];

    angular.forEach(widgets, function(w) {
      if (w.color === filters.color) {
        groupedWidgets.push(w);
      }
    });

    angular.forEach(groupedWidgets, function(widget){

      if (!widget.access || widget.access === 'all') {
        matching.push(widget);
        return;
      }

      var access = widget.access.split(' ');
      var mainSub = filters.isMain ? '-main' : '-sub';

      access.forEach(function(a) {
        if ((a === filters.accountType) || (a === filters.accountType + mainSub)) {
          matching.push(widget);
        }
      });
    });

    return matching;
  };
});

module.filter('formatTimer', function() {
  return function(input) {
    function z(n) {return (n<10? '0' : '') + n;}
    var seconds = input % 60;
    var minutes = Math.floor(input / 60);
    return (z(minutes)+':'+z(seconds));
  };
});

module.filter('creditCardFilter', function(){
  return function(number){
    if(!number){ return ''; }

    var card = number.substring(0, 4) + '-' + number.substring(4, 8) + '-' + number.substring(8, 12) + '-' + number.substring(12, 16);

    return card;
  };
});


module.filter('expFilter', function(){
  return function(exp){
    if(!exp){ return ''; }

    var expDate = exp.substring(4, 6) + '/' + exp.substring(2, 4);

    return expDate;
  };
});

module.filter('phoneNumberFilter', function(){
  return function (tel) {
    if (!tel) { return ''; }

    var value = tel.toString().trim().replace(/^\+/, '');

    if (value.match(/[^0-9]/)) {
      return tel;
    }

    var country, city, number;

    switch (value.length) {
      case 10: // +1PPP####### -> C (PPP) ###-####
        country = 1;
        city = value.slice(0, 3);
        number = value.slice(3);
        break;

      case 11: // +CPPP####### -> CCC (PP) ###-####
        country = value[0];
        city = value.slice(1, 4);
        number = value.slice(4);
        break;

      case 12: // +CCCPP####### -> CCC (PP) ###-####
        country = value.slice(0, 3);
        city = value.slice(3, 5);
        number = value.slice(5);
        break;

      default:
        return tel;
    }

    if (country == 1) {
      country = "";
    }

    number = number.slice(0, 3) + '-' + number.slice(3);

    return (country + " (" + city + ") " + number).trim();
  };
});
